import { useEffect, useRef, useState } from 'react';
import './SearchDropDown.css';

import Select from 'react-select';

type AppOption = {
  label: string;
  value: string;
};

const SearchDropDown = (props: any) => {
  const { options, placeholder, selectedVal, handleChange } = props;
  const [filteredOptions, setFilteredOptions] = useState<AppOption[]|[]>([]);
  const [selectedOption, setSelectedOption] = useState<AppOption | null>(null);
  const [inputValue, setInputValue] = useState<string>(selectedVal); // Manage input value separately
  useEffect(() => {
    if (selectedVal) {
      const matchedOption = options.find((option: AppOption) => option.value === selectedVal);
      setSelectedOption(matchedOption || null);
    }
  }, [selectedVal, options]);


  const handleInputChange = (input: string) => {
    setInputValue(input);
    if (!input|| input.length < 2) {
      setFilteredOptions([]);
      return;
    }
    const filtered = options.filter((option: AppOption) =>
      option.label.toLowerCase().includes(input.toLowerCase())
    );
    setFilteredOptions(filtered.slice(0, 50));
  };

  const setChosenOption = (option: any) => {
    setSelectedOption(option);
    handleChange(option?.value || '');
  };

  
  return (
    <Select<AppOption>
      options={filteredOptions}
      value={selectedOption}
      onChange={setChosenOption}
      onInputChange={handleInputChange}
      inputValue={inputValue}
      placeholder={placeholder}
      isClearable
      noOptionsMessage={() => 'Type atleast 2 characters'}
      required
    />
  );
};

export default SearchDropDown;
